import React, { useState, useEffect } from 'react'
import Header from '../BaseComponents/Header'
import FotterMain from '../BaseComponents/FotterMain';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { Link } from 'react-router-dom';
import { baseURL } from '../../networkCalls';
import { Helmet } from 'react-helmet';
import SEO from '../BaseComponents/SEO';

const Calculator = () => {
  const [cfl, setCFL] = useState(0);
  const [cflload, setCFLLoad] = useState(0);
  const cflChange = (value) => {
    if (value == 'plus') {
      setCFL(cfl + 1)
    }
    else {
      setCFL(cfl - 1)
    }
  };
  useEffect(() => {
    setCFLLoad(cfl * 20)
  }, [cfl]);

  const [tubeL, setTubeL] = React.useState(0);
  const [tubeLload, setTubeLload] = React.useState(0);
  const tubeLChange = (value) => {
    if (value == 'plus') {
      setTubeL(tubeL + 1)
    }
    else {
      setTubeL(tubeL - 1)
    }
  };
  useEffect(() => {
    setTubeLload(tubeL * 40)
  }, [tubeL]);

  const [fanL, setFanL] = useState(0);
  const [fabload, setFabload] = useState(0);
  const fanChange = (value) => {
    if (value == 'plus') {
      setFanL(fanL + 1)
    }
    else {
      setFanL(fanL - 1)
    }
  };
  useEffect(() => {
    setFabload(fanL * 45)
  }, [fanL]);



  const [buldL, setBuldL] = useState(0);
  const [bulbload, setBulbload] = useState(0);
  const buldChange = (value) => {
    if (value == 'plus') {
      setBuldL(buldL + 1)
    }
    else {
      setBuldL(buldL - 1)
    }
  };
  useEffect(() => {
    setBulbload(buldL * 60)
  }, [buldL]);

  const [tvL, settvL] = useState(0);
  const [tvload, settvload] = useState(0);
  const tvLChange = (value) => {
    if (value == 'plus') {
      settvL(tvL + 1)
    }
    else {
      settvL(tvL - 1)
    }
  };
  useEffect(() => {
    settvload(tvL * 120)
  }, [tvL]);


  const [refL, setRefL] = useState(0);
  const [refload, setRefload] = useState(0);
  const refLChange = (value) => {
    if (value == 'plus') {
      setRefL(refL + 1)
    }
    else {
      setRefL(refL - 1)
    }
  };
  useEffect(() => {
    setRefload(refL * 600)
  }, [refL]);


  const [coolerL, setCoolerL] = useState(0);
  const [coolerload, setCoolerload] = useState(0);
  const coolerLChange = (value) => {
    if (value == 'plus') {
      setCoolerL(coolerL + 1)
    }
    else {
      setCoolerL(coolerL - 1)
    }
  };
  useEffect(() => {
    setCoolerload(coolerL * 1200)
  }, [coolerL]);


  const [motorL, setMotorL] = React.useState(0);
  const [motorload, setMotorload] = React.useState(0);
  const motorLChange = (value) => {
    if (value == 'plus') {
      setMotorL(motorL + 1)
    }
    else {
      setMotorL(motorL - 1)
    }
  };
  useEffect(() => {
    setMotorload(motorL * 2000)
  }, [motorL]);

  const [geyserL, setGeyserL] = React.useState(0);
  const [geyserload, setGeyserload] = React.useState(0);
  const geyserLChange = (value) => {
    if (value == 'plus') {
      setGeyserL(geyserL + 1)
    }
    else {
      setGeyserL(geyserL - 1)
    }
  };
  useEffect(() => {
    setGeyserload(geyserL * 2000)
  }, [geyserL]);

  const [acL, setAcL] = React.useState(0);
  const [acload, setAcload] = React.useState(0);
  const acLChange = (value) => {
    if (value == 'plus') {
      setAcL(acL + 1)
    }
    else {
      setAcL(acL - 1)
    }
  };
  useEffect(() => {
    setAcload(acL * 2500)
  }, [acL]);


  var totalLoad = cflload + tubeLload + fabload + bulbload + tvload + refload + coolerload + motorload + geyserload + acload;
  //const enabledbtn = totalLoad > 0;

  const setClear = () => {
    setCFL(0);
    setCFLLoad(0);
    setTubeL(0);
    setTubeLload(0);
    setFanL(0);
    setFabload(0);
    setBuldL(0);
    setBulbload(0);
    settvL(0);
    settvload(0);
    setRefL(0);
    setRefload(0);
    setCoolerL(0);
    setCoolerload(0);
    setMotorL(0);
    setMotorload(0);
    setGeyserL(0);
    setGeyserload(0);
    setAcL(0);
    setAcload(0);
  }
  const toTop = () => {
    window.scrollTo(0, 0);
  }
  useEffect(() => {
    toTop();
  }, []);

  return (
    <>
      <SEO
        title="Honda India Power Products | Power Calculator"
        description="Our easy-to-use Load Calculator will help you to know the exact total load requirements for your property!"
        name="HIPP - Honda India Power"
        url="https://www.hondaindiapower.com/calculator"
        type='Website' />
      <Header />
      <div className='innerpagebg pt-5 pb-5'>
        <div className='container mb-4'>
          <div className='row'>
            <div className='col-12  m-auto'>
              <div className="align-items-center text-center">
                <h4 className='d-inline-block m-0 fw-bold text-uppercase'>
                  <span className='txtred'>MODEL</span> <span className='txtdgray'>CALCULATOR</span>
                </h4>
                <p className='mt-2 f16'>(ONLY FOR GENSETS)</p>
              </div>
            </div>
          </div>
        </div>
        <div className='container'>
          <div className='row '>
            <div className='col-12 col-lg-8'>
              <div className='row' style={{maxHeight:'600px', overflow:'auto'}}>
                <div className='col-lg-12 col-12 mb-3'>
                  <div className='card p-3'>
                    <div className='d-flex'>
                      <div className='flex-grow-1'>
                        <div className='d-flex align-items-center justify-content-between'>
                          <div>
                            <div className='fw-bold f16 mb-1'>CFL</div>
                            <div className='f12'><span className='fw-bold text-muted'>Load</span> 20W | <span className='fw-bold text-muted'>Starting Load</span> 20W</div>
                          </div>
                          <div>
                            <div className='d-flex align-items-center'>
                              {cfl <= 0 ? <>
                                <IconButton
                                  disabled
                                  size="medium" color="inherit" >
                                  <IndeterminateCheckBoxIcon color="bgdgray" />
                                </IconButton>
                              </> : <>
                                <IconButton size="medium" onClick={() => { cflChange('minus') }} color="inherit" >
                                  <IndeterminateCheckBoxIcon color="bgdgray" />
                                </IconButton>
                              </>}
                              <div className='p-1 pe-2 ps-2 bgsgray'>
                                {cfl}
                              </div>
                              <IconButton size="medium" onClick={() => { cflChange('plus') }} color="inherit" >
                                <AddBoxIcon color="success" />
                              </IconButton>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-lg-12 col-12 mb-3'>
                  <div className='card p-3'>
                    <div className='d-flex'>
                      <div className='flex-grow-1'>
                        <div className='d-flex align-items-center justify-content-between'>
                          <div>
                            <div className='fw-bold f16 mb-1'>Tube Lights</div>
                            <div className='f12'><span className='fw-bold text-muted'>Load</span> 40W | <span className='fw-bold text-muted'>Starting Load</span> 40W</div>
                          </div>
                          <div>
                            <div className='d-flex align-items-center mt-2'>
                              {tubeL <= 0 ? <>
                                <IconButton
                                  disabled
                                  size="medium" color="inherit" >
                                  <IndeterminateCheckBoxIcon color="bgdgray" />
                                </IconButton>
                              </> : <>
                                <IconButton size="medium" onClick={() => { tubeLChange('minus') }} color="inherit" >
                                  <IndeterminateCheckBoxIcon color="bgdgray" />
                                </IconButton>
                              </>}
                              <div className='p-1 pe-2 ps-2 bgsgray'>
                                {tubeL}
                              </div>
                              <IconButton size="medium" onClick={() => { tubeLChange('plus') }} color="inherit" >
                                <AddBoxIcon color="success" />
                              </IconButton>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-lg-12 col-12 mb-3'>
                  <div className='card p-3'>
                    <div className='d-flex'>
                      <div className='flex-grow-1'>

                        <div className='d-flex align-items-center justify-content-between'>
                          <div>
                            <div className='fw-bold f16 mb-1'>Fan</div>
                            <div className='f12'><span className='fw-bold text-muted'>Load</span> 45W | <span className='fw-bold text-muted'>Starting Load</span> 45W</div>
                          </div>
                          <div>
                            <div className='d-flex align-items-center mt-2'>
                              {fanL <= 0 ? <>
                                <IconButton
                                  disabled
                                  size="medium" color="inherit" >
                                  <IndeterminateCheckBoxIcon color="bgdgray" />
                                </IconButton>
                              </> : <>
                                <IconButton size="medium" onClick={() => { fanChange('minus') }} color="inherit" >
                                  <IndeterminateCheckBoxIcon color="bgdgray" />
                                </IconButton>
                              </>}
                              <div className='p-1 pe-2 ps-2 bgsgray'>
                                {fanL}
                              </div>
                              <IconButton size="medium" onClick={() => { fanChange('plus') }} color="inherit" >
                                <AddBoxIcon color="success" />
                              </IconButton>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-lg-12 col-12 mb-3'>
                  <div className='card p-3'>
                    <div className='d-flex'>
                      <div className='flex-grow-1'>

                        <div className='d-flex align-items-center justify-content-between'>
                          <div>
                            <div className='fw-bold f16 mb-1'>Bulb</div>
                            <div className='f12'><span className='fw-bold text-muted'>Load</span> <span className='fw-bold text-muted'>60W | Starting Load</span> 60W</div>
                          </div>
                          <div>
                            <div className='d-flex align-items-center mt-2'>
                              {buldL <= 0 ? <>
                                <IconButton
                                  disabled
                                  size="medium" color="inherit" >
                                  <IndeterminateCheckBoxIcon color="bgdgray" />
                                </IconButton>
                              </> : <>
                                <IconButton size="medium" onClick={() => { buldChange('minus') }} color="inherit" >
                                  <IndeterminateCheckBoxIcon color="bgdgray" />
                                </IconButton>
                              </>}
                              <div className='p-1 pe-2 ps-2 bgsgray'>
                                {buldL}
                              </div>
                              <IconButton size="medium" onClick={() => { buldChange('plus') }} color="inherit" >
                                <AddBoxIcon color="success" />
                              </IconButton>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-lg-12 col-12 mb-3'>
                  <div className='card p-3'>
                    <div className='d-flex'>
                      <div className='flex-grow-1'>

                        <div className='d-flex align-items-center justify-content-between'>
                          <div>
                            <div className='fw-bold f16 mb-1'>TV</div>
                            <div className='f12'><span className='fw-bold text-muted'>Load</span> 120W | <span className='fw-bold text-muted'>Starting Load</span> 120W</div>
                          </div>
                          <div>
                            <div className='d-flex align-items-center mt-2'>
                              {tvL <= 0 ? <>
                                <IconButton
                                  disabled
                                  size="medium" color="inherit" >
                                  <IndeterminateCheckBoxIcon color="bgdgray" />
                                </IconButton>
                              </> : <>
                                <IconButton size="medium" onClick={() => { tvLChange('minus') }} color="inherit" >
                                  <IndeterminateCheckBoxIcon color="bgdgray" />
                                </IconButton>
                              </>}
                              <div className='p-1 pe-2 ps-2 bgsgray'>
                                {tvL}
                              </div>
                              <IconButton size="medium" onClick={() => { tvLChange('plus') }} color="inherit" >
                                <AddBoxIcon color="success" />
                              </IconButton>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-lg-12 col-12 mb-3'>
                  <div className='card p-3'>
                    <div className='d-flex'>
                      <div className='flex-grow-1'>

                        <div className='d-flex align-items-center justify-content-between'>
                          <div>
                            <div className='fw-bold f16 mb-1'>Refrigerator</div>
                            <div className='f12'><span className='fw-bold text-muted'>Load</span> 200W | <span className='fw-bold text-muted'>Starting Load</span> 600W</div>
                          </div>
                          <div>
                            <div className='d-flex align-items-center mt-2'>
                              {refL <= 0 ? <>
                                <IconButton
                                  disabled
                                  size="medium" color="inherit" >
                                  <IndeterminateCheckBoxIcon color="bgdgray" />
                                </IconButton>
                              </> : <>
                                <IconButton size="medium" onClick={() => { refLChange('minus') }} color="inherit" >
                                  <IndeterminateCheckBoxIcon color="bgdgray" />
                                </IconButton>
                              </>}
                              <div className='p-1 pe-2 ps-2 bgsgray'>
                                {refL}
                              </div>
                              <IconButton size="medium" onClick={() => { refLChange('plus') }} color="inherit" >
                                <AddBoxIcon color="success" />
                              </IconButton>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-lg-12 col-12 mb-3'>
                  <div className='card p-3'>
                    <div className='d-flex'>
                      <div className='flex-grow-1'>

                        <div className='d-flex align-items-center justify-content-between'>
                          <div>
                            <div className='fw-bold f16 mb-1'>Air Cooler</div>
                            <div className='f12'><span className='fw-bold text-muted'>Load</span> 400W | <span className='fw-bold text-muted'>Starting Load</span> 1200W</div>
                          </div>
                          <div>
                            <div className='d-flex align-items-center mt-2'>
                              {coolerL <= 0 ? <>
                                <IconButton
                                  disabled
                                  size="medium" color="inherit" >
                                  <IndeterminateCheckBoxIcon color="bgdgray" />
                                </IconButton>
                              </> : <>
                                <IconButton size="medium" onClick={() => { coolerLChange('minus') }} color="inherit" >
                                  <IndeterminateCheckBoxIcon color="bgdgray" />
                                </IconButton>
                              </>}
                              <div className='p-1 pe-2 ps-2 bgsgray'>
                                {coolerL}
                              </div>
                              <IconButton size="medium" onClick={() => { coolerLChange('plus') }} color="inherit" >
                                <AddBoxIcon color="success" />
                              </IconButton>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-lg-12 col-12 mb-3'>
                  <div className='card p-3'>
                    <div className='d-flex'>
                      <div className='flex-grow-1'>

                        <div className='d-flex align-items-center justify-content-between'>
                          <div>
                            <div className='fw-bold f16 mb-1'>Water Motor</div>
                            <div className='f12'><span className='fw-bold text-muted'>Load</span> 750W | <span className='fw-bold text-muted'>Starting Load</span> 2000W</div>

                          </div>
                          <div>
                            <div className='d-flex align-items-center mt-2'>
                              {motorL <= 0 ? <>
                                <IconButton
                                  disabled
                                  size="medium" color="inherit" >
                                  <IndeterminateCheckBoxIcon color="bgdgray" />
                                </IconButton>
                              </> : <>
                                <IconButton size="medium" onClick={() => { motorLChange('minus') }} color="inherit" >
                                  <IndeterminateCheckBoxIcon color="bgdgray" />
                                </IconButton>
                              </>}
                              <div className='p-1 pe-2 ps-2 bgsgray'>
                                {motorL}
                              </div>
                              <IconButton size="medium" onClick={() => { motorLChange('plus') }} color="inherit" >
                                <AddBoxIcon color="success" />
                              </IconButton>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-lg-12 col-12 mb-3'>
                  <div className='card p-3'>
                    <div className='d-flex'>
                      <div className='flex-grow-1'>

                        <div className='d-flex align-items-center justify-content-between'>
                          <div>
                            <div className='fw-bold f16 mb-1'>Geyser</div>
                            <div className='f12'><span className='fw-bold text-muted'>Load</span> 2000W | <span className='fw-bold text-muted'>Starting Load</span> 2000W</div>

                          </div>
                          <div>
                            <div className='d-flex align-items-center mt-2'>
                              {geyserL <= 0 ? <>
                                <IconButton
                                  disabled
                                  size="medium" color="inherit" >
                                  <IndeterminateCheckBoxIcon color="bgdgray" />
                                </IconButton>
                              </> : <>
                                <IconButton size="medium" onClick={() => { geyserLChange('minus') }} color="inherit" >
                                  <IndeterminateCheckBoxIcon color="bgdgray" />
                                </IconButton>
                              </>}
                              <div className='p-1 pe-2 ps-2 bgsgray'>
                                {geyserL}
                              </div>
                              <IconButton size="medium" onClick={() => { geyserLChange('plus') }} color="inherit" >
                                <AddBoxIcon color="success" />
                              </IconButton>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-lg-12 col-12 mb-3'>
                  <div className='card p-3'>
                    <div className='d-flex'>
                      <div className='flex-grow-1'>

                        <div className='d-flex align-items-center justify-content-between'>
                          <div>
                            <div className='fw-bold f16 mb-1'>AC (1.5 T ***** Rating)</div>
                            <div className='f12'><span className='fw-bold text-muted'>Load</span> 2100W | <span className='fw-bold text-muted'>Starting Load</span> 2500W</div>
                          </div>
                          <div>
                            <div className='d-flex align-items-center mt-2'>
                              {acL <= 0 ? <>
                                <IconButton
                                  disabled
                                  size="medium" color="inherit" >
                                  <IndeterminateCheckBoxIcon color="bgdgray" />
                                </IconButton>
                              </> : <>
                                <IconButton size="medium" onClick={() => { acLChange('minus') }} color="inherit" >
                                  <IndeterminateCheckBoxIcon color="bgdgray" />
                                </IconButton>
                              </>}
                              <div className='p-1 pe-2 ps-2 bgsgray'>
                                {acL}
                              </div>
                              <IconButton size="medium" onClick={() => { acLChange('plus') }} color="inherit" >
                                <AddBoxIcon color="success" />
                              </IconButton>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

            </div>
            <div className='col-12 col-lg-4'>
              <div className=''>
                <div className='card p-4'>
                  <div className='text-center'>
                    <h3 className='m-0 p-0 f20'>TOTAL LOAD</h3>
                    <p className='mt-3 f20 mb-0 fw-bold text-danger'>{totalLoad} W</p>
                  </div>
                  <div>
                    <div className='text-center mt-4'>
                      <Button color="error" onClick={() => setClear()} variant="text" className='' size='small' type="submit">
                        clear Load
                      </Button>
                      {/* <Button color="error" disabled={!enabledbtn} variant="outlined" className='' size='small' type="submit">
                      Submit
                    </Button> */}
                    </div>
                  </div>
                </div>
                <div>
                  {totalLoad > 10 && totalLoad <= 750 ? <>
                    <div className="product-card product-card--layout--grid d-flex bg-white position-relative rounded mt-3">
                      <Link className="image__body" to="/product-detail/ep-1000">
                        <div className="product-card__image">
                          <div className="image image--type--product">
                            <img alt="EP 1000" className="img-fluid" src={`${baseURL}admin/public/uploads/Products/QvlVfFIzl_Cover.jpg`} />
                          </div>
                        </div>
                        <div className="product-card__info">
                          <div className="product-card__meta">
                            <span className="product-card__meta-title">GENERATORS</span>
                          </div>
                          <div className="product-card__name mb-4">
                            <div className="fw-bold f14" >EP 1000</div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </> : <></>}
                  {totalLoad > 750 && totalLoad <= 1800 ? <>
                    <div className="product-card product-card--layout--grid d-flex bg-white position-relative rounded mt-3">
                      <Link className="image__body" to="/product-detail/ex2400s">
                        <div className="product-card__image">
                          <div className="image image--type--product">
                            <img alt="EX2400S" className="img-fluid" src={`${baseURL}admin/public/uploads/Products/YfCyFjzdK_Cover.jpg`} />
                          </div>
                        </div>
                        <div className="product-card__info">
                          <div className="product-card__meta">
                            <span className="product-card__meta-title">GENERATORS</span>
                          </div>
                          <div className="product-card__name mb-4">
                            <div className="fw-bold f14">EX2400S</div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </> : <></>}
                  {totalLoad > 1800 && totalLoad <= 2800 ? <>
                    <div className="product-card product-card--layout--grid d-flex bg-white position-relative rounded mt-3">
                      <Link className="image__body" to="/product-detail/eu30is">
                        <div className="product-card__image">
                          <div className="image image--type--product">
                            <img alt="EU30is" className="img-fluid" src={`${baseURL}admin/public/uploads/Products/afwhLLGEV_Cover.jpg`} />
                          </div>
                        </div>
                        <div className="product-card__info">
                          <div className="product-card__meta">
                            <span className="product-card__meta-title">GENERATORS</span>
                          </div>
                          <div className="product-card__name mb-4">
                            <div className="fw-bold f14">EU30is</div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </> : <></>}
                  {totalLoad > 2800 && totalLoad < 5500 ? <>
                    <div className="product-card product-card--layout--grid d-flex bg-white position-relative rounded mt-3">
                      <Link className="image__body" to="/product-detail/eu70is">
                        <div className="product-card__image">
                          <div className="image image--type--product">
                            <img alt="EU70is" className="img-fluid" src={`${baseURL}admin/public/uploads/Products/xbmYBgRQ_Cover.jpg`} />
                          </div>
                        </div>
                        <div className="product-card__info">
                          <div className="product-card__meta">
                            <span className="product-card__meta-title">GENERATORS</span>
                          </div>
                          <div className="product-card__name mb-4">
                            <div className="fw-bold f14">EU70is</div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </> : <></>}
                </div>
              </div>


            </div>
          </div>

        </div>
      </div>
      <FotterMain />
    </>
  )
}

export default Calculator